import script from "./file-box.vue?vue&type=script&lang=ts&setup=true"
export * from "./file-box.vue?vue&type=script&lang=ts&setup=true"

import "./file-box.vue?vue&type=style&index=0&id=9221d7c2&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9221d7c2"]])

export default __exports__